import React from "react";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import Container from "@mui/material/Container";

const RankCard = (props) => {
  let trophyColor = "#7437B9"; // Gold color (default)
  let trophyIcon = "🏆"; // Trophy emoji (default)

  if (props.rank === 1) {
    trophyColor = "#FFD700";
  } else if (props.rank === 2) {
    trophyColor = "#C0C0C0"; // Silver color (2nd place)
  } else if (props.rank === 3) {
    trophyColor = "#CD7F32"; // Bronze color (3rd place)
  }

  return (
    <Container>
      <div className="my-5">
        <Card
          sx={{
            display: "flex",
            flexDirection: "column", 
            alignItems: "center", 
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            padding: "16px",
          }}
        >
          <Typography
            variant="h5"
            className="mx-3 my-3 fw-bold blue-text text-center"
          >
            Rank in Last Test - {props.subject}
          </Typography>
          <Avatar
            sx={{
              width: "9rem", 
              height: "9rem", 
              backgroundColor: trophyColor,
              fontSize: "7rem", 
            }}
          >
            {trophyIcon}
          </Avatar>
          <Typography
            variant="h4"
            className="orange-text mx-5 px-5 py-3 text-center"
            sx={{ fontSize: "6rem" }} // Adjust size for mobile
          >
            {props.rank}
          </Typography>
        </Card>
      </div>
    </Container>
  );
};

export default RankCard;
